import { FaFacebook } from 'react-icons/fa';

const iconStyle = (Icon) => <Icon />;


export const FooterPageData = {
	title: "© 2026. LTM Transportservice GbR.",
  };

export const footerSocialData = [
	{
		name: 'Facebook',
		icon: iconStyle(FaFacebook),
	},
];

export const footerData = [
	{
		title: 'Main',
		links: ['Blog', 'FAQs', 'Support', 'About us'],
	},
	{
		title: 'Product',
		links: ['Login', 'Personal', 'Business', 'Team'],
	},
	{
		title: 'Press',
		links: ['Logos', 'Events', 'Stories', 'Office'],
	},
	{
		title: 'Legal',
		links: ['GDPR', 'Privacy Policy', 'Terms of Service', 'Disclaimer'],
	},
];

export const data = [
	{
	  to: "/",
	  text: "Startseite",
	  id: "startseite",
	},
	// {
	//   to: "/rent",
	//   text: "Mieten",
	// },
	{
	  to: "/kfz",
	  text: "KFZ",
	},
	{
	  to: "/diy",
	  text: "Selbsthilfewerkstatt",
	},
	 {
    to: "/jobs",
    text: "Karriere",
  },
	{
	  to: "/contact",
	  text: "Kontakt",
	},
	{
	  to: "/aboutus",
	  text: "Über uns",
	},
  ];

  export const dataRights = [
	{
		to: "/copyright",
		text: "Impressum",
	  },
	{
	  to: "/privacy",
	  text: "Datenschutz",
	},
		{
	  to: "/credits",
	  text: "Credits",
	},
  ];
  